import { VIEWPORT_FRAGMENT } from 'features/globalSetup/features/viewport/hooks/useGetViewports/api/fragment'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_VIEWPORTS: TypedDocumentNode<Data, Variables> = gql`
  ${VIEWPORT_FRAGMENT}

  query getViewports($workspaceId: ID!, $sort: ViewportSortInput, $terms: [String!]) {
    viewports(workspaceId: $workspaceId, sort: $sort, terms: $terms) {
      nodes {
        ...ViewportFragment
      }
    }
  }
`
